import { render, staticRenderFns } from "./CargoRow.vue?vue&type=template&id=395ab1db&scoped=true"
import script from "./CargoRow.vue?vue&type=script&lang=js"
export * from "./CargoRow.vue?vue&type=script&lang=js"
import style0 from "./CargoRow.vue?vue&type=style&index=0&id=395ab1db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ab1db",
  null
  
)

export default component.exports